module.exports = __webpack_public_path__ + "static/media/testimonial.ffbe295c.svg";